"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaticItemType = isStaticItemType;
function isStaticItemType(itemType) {
    return itemType?.generationType === 'static';
}
//# sourceMappingURL=item.static.guard.js.map